import { notifyError } from "../../../redux/actions/notificacaoActions";
import LoteManager from "../loteManager";
import { listarLotesPorPasto } from "./loteAction";

/**
 * @deprecated in favor of typescript operations (not yet migrated)
 * - TODO: create a new operation to fetch lots in livestockOperations.ts and remove this one
 */
export const listaLotesPasto = (idPasto) => async (dispatch) => {
  try {
    const lotesPasto = await LoteManager.obterLotesPasto(idPasto);
    dispatch(listarLotesPorPasto(lotesPasto));
  } catch (error) {
    dispatch(listarLotesPorPasto([]));
    dispatch(
      notifyError({
        mensagem: "Ocorreu um erro ao obter a lotes desse pasto",
      })
    );
  }
};
